module.exports = __webpack_public_path__ + "static/media/bs.93ab4d05.svg";